import React from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { useSignupWizard } from '../../../contexts/SignupWizardContext';
import { en } from '../../../translations/en';

interface SignupStep4PaymentProps {
  onPaymentComplete?: () => void;
}

export const SignupStep4Payment: React.FC<SignupStep4PaymentProps> = ({ onPaymentComplete }) => {
  const { state } = useSignupWizard();

  // This component is shown when:
  // 1. User selected a paid tier and was redirected to Stripe
  // 2. User returns from Stripe payment

  // The actual payment handling happens via PaymentSuccess page
  // This component is mostly a placeholder/loading state

  React.useEffect(() => {
    // Check if payment was already completed (user returned from Stripe)
    if (state.paymentComplete && onPaymentComplete) {
      onPaymentComplete();
    }
  }, [state.paymentComplete, onPaymentComplete]);

  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <Typography variant="h6" gutterBottom>
        {en.signup.paymentProcessing.title}
      </Typography>

      {!state.paymentComplete ? (
        <>
          <CircularProgress sx={{ my: 3 }} />
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Processing your payment...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You will be redirected back after completing payment with Stripe.
          </Typography>
        </>
      ) : (
        <Alert severity="success" sx={{ mt: 2 }}>
          Payment completed successfully! Proceeding to create your account...
        </Alert>
      )}

      <Alert severity="info" sx={{ mt: 3, textAlign: 'left' }}>
        <Typography variant="body2">
          <strong>{en.signup.paymentProcessing.selectedPlan}</strong> {state.selectedTier}
        </Typography>
        <Typography variant="body2">
          {state.selectedTier === 'creator' ? (
            <>Price: $29.99/month</>
          ) : (
            <>Price: $99.99/month</>
          )}
        </Typography>
      </Alert>
    </Box>
  );
};

export default SignupStep4Payment;
